import React from "react";

export const WX = { 0: "Clear", 1: "Mostly clear", 2: "Partly cloudy", 3: "Overcast", 45: "Fog", 48: "Fog", 51: "Drizzle", 61: "Rain", 63: "Rain", 65: "Heavy rain", 80: "Showers", 95: "Thunderstorm" };

export const Corners = ({ accent }) => ["tl", "tr", "bl", "br"].map((c) => <span key={c} className={`nx-corner ${c}`} style={{ "--hud": accent }} />);

export const Card = ({ title, accent = "#00F0FF", children, className = "", testid, code }) => (
  <div className={`nx-hud rounded-3xl p-6 min-h-0 overflow-hidden flex flex-col ${className}`} data-testid={testid}>
    <Corners accent={accent} />
    {title && (
      <div className="flex items-center gap-3 mb-4 shrink-0 relative z-10">
        <span className="w-2.5 h-2.5 rotate-45 animate-pulse" style={{ background: accent, boxShadow: `0 0 10px ${accent}` }} />
        <p className="nx-orbitron text-lg tracking-[0.25em] font-bold" style={{ color: accent, textShadow: `0 0 12px ${accent}66` }}>{title}</p>
        <span className="flex-1 h-px" style={{ background: `linear-gradient(90deg, ${accent}66, transparent)` }} />
        <span className="nx-mono text-xs tracking-widest" style={{ color: `${accent}88` }}>{code || "SYS·OK"}</span>
      </div>
    )}
    <div className="flex-1 min-h-0 overflow-hidden relative z-10">{children}</div>
  </div>
);

export const Ring = ({ value, max = 100, color, size = 120, label, sub }) => {
  const r = 15.9, pctv = Math.max(0, Math.min(1, (value || 0) / max));
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <svg viewBox="0 0 36 36" className="absolute inset-0 nx-spin-slow" style={{ opacity: 0.5 }}>
        <circle cx="18" cy="18" r="17.4" fill="none" stroke={color} strokeWidth="0.3" strokeDasharray="1 2.2" />
      </svg>
      <svg viewBox="0 0 36 36" className="absolute inset-0">
        <circle cx="18" cy="18" r={r} fill="none" stroke="#ffffff12" strokeWidth="2.6" />
        <circle cx="18" cy="18" r={r} fill="none" stroke={color} strokeWidth="2.6" strokeLinecap="round"
          strokeDasharray={`${pctv * 100} 100`} transform="rotate(-90 18 18)" style={{ filter: `drop-shadow(0 0 3px ${color})`, transition: "stroke-dasharray 1s" }} />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-black text-white" style={{ fontSize: size * 0.28 }}>{label ?? Math.round(value || 0)}</span>
        {sub && <span className="nx-mono tracking-widest" style={{ fontSize: Math.max(10, size * 0.09), color }}>{sub}</span>}
      </div>
    </div>
  );
};

export const Empty = ({ children }) => <p className="text-2xl text-cyan-100/40">{children}</p>;

export const pct = (v) => `${v > 0 ? "+" : ""}${Number(v || 0).toFixed(1)}%`;
export const tone = (v) => (v > 0 ? "text-emerald-300" : v < 0 ? "text-rose-300" : "text-cyan-100");
